import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _map from 'lodash/map';
import ReactModal from 'react-modal';
import s from './MLFullPageDialog.module.css';

// deprecated: use MLFullScreenDialog instead
class MLFullPageDialog extends Component {
  static defaultProps = {
    onActionsSubmit: null,
    titleClassName: '',
    className: '',
    bodyClassName: '',
    isRequired: true,
    showBanner: false,
    disableEnforceFocus: false,
  };

  static propTypes = {
    onClose: PropTypes.func,
    show: PropTypes.bool.isRequired,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    actions: PropTypes.array,
    onActionsSubmit: PropTypes.func,
    titleClassName: PropTypes.string,
    className: PropTypes.string,
    bodyClassName: PropTypes.string,
    isRequired: PropTypes.bool,
    testId: PropTypes.string,
    // eslint-disable-next-line react/no-unused-prop-types
    closeTestId: PropTypes.string,
    showBanner: PropTypes.bool,
    renderBanner: PropTypes.func,
    disableEnforceFocus: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    const { onActionsSubmit } = this.props;
    if (onActionsSubmit) {
      const keydownListener = this.handleKeyDown.bind(this);
      document.addEventListener('keydown', keydownListener);
      this.setState({ keydownListener });
    }
    this.state = {
      keydownListener: null,
    };
  }

  componentDidMount() {
    ReactModal.setAppElement('body');

    // make background not scrollable
    const container = document.getElementById('container');
    if (container) container.classList.add(s.__dialogOpen);
    // make background not focusable
    if (container) ReactModal.setAppElement(container);
  }

  componentWillUnmount() {
    const { keydownListener } = this.state;
    if (keydownListener) {
      document.removeEventListener('keydown', keydownListener);
    }
    // make background scrollable
    const container = document.getElementById('container');
    if (container) container.classList.remove(s.__dialogOpen);
  }

  handleKeyDown(e) {
    if (e.keyCode === 13) {
      this.props.onActionsSubmit();
    }
  }

  renderTitle() {
    const { title } = this.props;
    if (typeof title === 'string') {
      return (
        <span className={s.dialogTitleText} id="__mlDialog_title">
          {title}
        </span>
      );
    }
    return (
      <div className={s.dialogTitleContainer} id="__mlDialog_title">
        {title}
      </div>
    );
  }

  renderActions() {
    const { actions } = this.props;
    return _map(actions, (action) => {
      const actionClassName = action.props.actionClassName || '';
      return (
        <div key={`${action.props.children}_key`} className={actionClassName}>
          {action}
        </div>
      );
    });
  }

  render() {
    const {
      show,
      onClose,
      children,
      title,
      titleClassName,
      className,
      bodyClassName,
      isRequired,
      testId,
      renderBanner,
      showBanner,
      disableEnforceFocus,
    } = this.props;

    const parentSelector = () => document.body;
    const handleOnClose = () => {
      if (onClose) {
        onClose();
      }
    };

    return (
      <ReactModal
        key="react-modal"
        contentLabel=""
        className={`${s.dialog} ${className}`}
        overlayClassName={s.dialogOverlay}
        isOpen={show}
        onRequestClose={handleOnClose}
        role="dialog"
        aria={{
          labelledby: '__mlDialog_title',
          modal: 'true',
        }}
        shouldCloseOnOverlayClick={!isRequired}
        parentSelector={parentSelector}
        data={{ 'test-id': testId }}
        shouldFocusAfterRender={!disableEnforceFocus}
      >
        <div
          className={
            title === ''
              ? s.dialogNoTitle
              : `${s.dialogTitle} ${titleClassName}`
          }
        >
          {this.renderTitle()}
          <div className={s.actionContainer}>{this.renderActions()}</div>
        </div>
        {showBanner && renderBanner()}
        <div className={`${s.dialogBody} ${bodyClassName}`}>{children}</div>
      </ReactModal>
    );
  }
}

export default MLFullPageDialog;
